export type RegionalAdminBaseParams = {
  statsType: string;
  year: string; // could be number but leaving as string for now
};

export type RegionalAdminExtendedScopeAndCourse = RegionalAdminBaseParams & {
  scope: string;
  courseId: string;
};

export type CategoryExtension = {
  categoryGroupId: string;
};

export type LogicalErrorExtension = {
  logicalErrorId: string;
};

export const REGIONAL_ADMIN_ROUTE = {
  DEFAULT: '',
  name: 'regionaladmin',
  route(): string[] {
    return ['/', this.name];
  },
  HELP_CENTER: {
    name: 'helpcenter',
    route(): string[] {
      return [...REGIONAL_ADMIN_ROUTE.route(), this.name];
    }
  },
  GAP_RESULTS: {
    name: 'gapresults/:statsType/:year/:scope/:courseId/:logicalErrorId',
    route(params: RegionalAdminExtendedScopeAndCourse & LogicalErrorExtension): string[] {
      return [
        ...REGIONAL_ADMIN_ROUTE.route(),
        'gapresults',
        params.statsType,
        params.year,
        params.scope,
        params.courseId,
        params.logicalErrorId
      ];
    }
  },
  REGIONAL_DASHBOARD: {
    name: 'regionaldashboard',
    route(year: number): string[] {
      return [...REGIONAL_ADMIN_ROUTE.route(), this.name, year.toString()];
    }
  },
  REGIONAL_INSIGHTS: {
    name: 'regionalinsights/:StatsType/:Year',
    route(statsType = 'D', year = '0'): string[] {
      return [...REGIONAL_ADMIN_ROUTE.route(), 'regionalinsights', statsType, year];
    }
  },
  REGIONAL_INSIGHTS_DETAIL: {
    name: 'regionalinsightsdetail/:statsType/:year/:scope/:courseId/:categoryGroupId',
    route(params: RegionalAdminExtendedScopeAndCourse & CategoryExtension): string[] {
      return [
        ...REGIONAL_ADMIN_ROUTE.route(),
        'regionalinsightsdetail',
        params.statsType,
        params.year,
        params.scope,
        params.courseId,
        params.categoryGroupId
      ];
    }
  },
  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...REGIONAL_ADMIN_ROUTE.route(), this.name];
    }
  }
};
